import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Expertise } from './pages/Expertise';
import { Career } from './pages/Career';
import { Impact } from './pages/Impact';
import { Framework } from './pages/Framework';
import { Credentials } from './pages/Credentials';
import { Insights } from './pages/Insights';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28ufp6dtutik4">
      <div className="flex min-h-screen w-full flex-col bg-parchment font-serif" data-id="element-1" data-mp="28tw5arkn8k3g">
        <ScrollToTop data-id="element-2" data-mp="23vcikoy874a1" />
        <Nav data-id="element-3" data-mp="23w4fc33k781w" />
        <main className="flex-1" data-id="element-4" data-mp="23u9vyt7xrnzx">
          <Routes data-id="element-5" data-mp="23t8iki3g6pf1">
            <Route path="/" element={<Home data-id="element-7" data-mp="3ikh5q2ysagvt" />} data-id="element-6" data-mp="3ijxnsm94vshs" />
            <Route path="/about" element={<About data-id="element-9" data-mp="3ihv048vgebg8" />} data-id="element-8" data-mp="3ij66mgga9xb1" />
            <Route path="/expertise" element={<Expertise data-id="element-11" data-mp="3mkhn9wh6j873" />} data-id="element-10" data-mp="3mlawd43m29se" />
            <Route path="/career" element={<Career data-id="element-13" data-mp="3rc9dg5wfbbwp" />} data-id="element-12" data-mp="3mjq2zht18ww4" />
            <Route path="/impact" element={<Impact data-id="element-15" data-mp="3rcsyvwla8ifh" />} data-id="element-14" data-mp="3rbzmaezn6ypf" />
            <Route path="/framework" element={<Framework data-id="element-17" data-mp="6hp9c27i9cj" />} data-id="element-16" data-mp="3reltuemj9e7n" />
            <Route path="/credentials" element={<Credentials data-id="element-19" data-mp="7su7f7e1n58" />} data-id="element-18" data-mp="4n5w26l2pak" />
            <Route path="/insights" element={<Insights data-id="element-21" data-mp="2zmenq84nlk7i" />} data-id="element-20" data-mp="2zlle8zeb8glo" />
            <Route path="/contact" element={<Contact data-id="element-23" data-mp="33mf0loc3tncg" />} data-id="element-22" data-mp="2zn6biws0edn8" />
            <Route path="*" element={<Home data-id="element-25" data-mp="33n6w6z5pbl2q" />} data-id="element-24" data-mp="33nq4rp9gox43" />
          </Routes>
        </main>
        <Footer data-id="element-26" data-mp="38l8h7pmotugu" />
      </div>
    </BrowserRouter>;
}